/** https://developers.google.com/web/updates/2016/01/mediarecorder */

export const getMediaOptions = (type: 'audio' | 'video'): MediaRecorderOptions => {
  const candidates: MediaRecorderOptions[] =
    type === 'video'
      ? [{ mimeType: 'video/webm;codecs=vp9' }, { mimeType: 'video/webm' }]
      : [
          // Chrome / Firefox / Edge
          { mimeType: 'audio/webm;codecs=opus', audioBitsPerSecond: 256000 },
          { mimeType: 'audio/webm' },
          // Safari (iOS / macOS) — does not support webm, only mp4
          { mimeType: 'audio/mp4;codecs=mp4a.40.2', audioBitsPerSecond: 256000 },
          { mimeType: 'audio/mp4' },
          // audio-recorder-polyfill fallback (older Safari without native MediaRecorder)
          { mimeType: 'audio/wav' },
        ]

  for (const options of candidates) {
    if (options.mimeType && MediaRecorder.isTypeSupported(options.mimeType)) {
      return options
    }
  }
  throw new Error(`Cannot find any supported codecs for ${type}`)
}
